import React, { Component, Fragment } from "react";

import Entryform from "./components/Entryform";
import Entryform2 from "./components/Entryform2";
import { Route } from "react-router-dom";
import Outlets from "./components/outlets";
import Menu from "./components/Menu";
import OrderF from "./components/OrderF";
import OrderDetail from "./components/OrderDetail";
import MoreD from "./components/MoreD";
class App extends Component {
  render() {
    return (
      <Fragment>
        <Route path="/food-booking" exact component={Entryform} />
        <Route
          path="/food-booking/trainNo/:trainNo"
          exact
          component={Entryform2}
        />

        <Route path="/food-booking/outlets" exact component={Outlets} />

        <Route
          path="/food-booking/:trainN/:trainNO/:doj/:sta/:provider/:delC/:stationCode/:minOrder/:StaN/:outletName/:outletId"
          exact
          component={Menu}
        />

        <Route path="/food-booking/order/:id/:email" exact component={OrderF} />
        <Route
          path="/food-booking/Allorder/details/:id/:email"
          exact
          component={OrderDetail}
        />
        <Route
          path="/food-booking/orderdetails/:id/:Status"
          exact
          component={MoreD}
        />
      </Fragment>
    );
  }
}

export default App;
